import React, { useState } from 'react';

// Shows an image, or a generated abstract visual when there is no src or loading fails.
export default function SafeImage({ src, alt, seed = 0 }) {
  const [failed, setFailed] = useState(false);
  if (src && !failed) {
    return <img src={src} alt={alt} loading="lazy" onError={() => setFailed(true)} />;
  }
  return (
    <svg viewBox="0 0 400 240" role="img" aria-label={alt} preserveAspectRatio="xMidYMid slice">
      <defs>
        <linearGradient id={`g${seed}`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor={`#061609`} />
          <stop offset="1" stopColor={`#34373f`} />
        </linearGradient>
      </defs>
      <rect width="400" height="240" fill={`url(#g${seed})`} />
      <rect x="40" y="36" width="320" height="168" rx="10" fill="#fff" opacity=".08" />
      <rect x="40" y="36" width="320" height="22" rx="10" fill="#fff" opacity=".12" />
      <rect x="60" y="76" width="110" height="10" rx="5" fill="#80c342" />
      <rect x="60" y="98" width="180" height="8" rx="4" fill="#fff" opacity=".35" />
      <rect x="60" y="116" width="150" height="8" rx="4" fill="#fff" opacity=".25" />
      <rect x="60" y="150" width="60" height="36" rx="6" fill="#fff" opacity=".15" />
      <rect x="130" y="150" width="60" height="36" rx="6" fill="#fff" opacity=".15" />
      <rect x="200" y="150" width="60" height="36" rx="6" fill="#80c342" opacity=".7" />
      <circle cx="310" cy="120" r="38" fill="none" stroke="#80c342" strokeWidth="10" strokeDasharray="150 90" />
    </svg>
  );
}
